export default __webpack_public_path__ + "static/media/logo_tpbank.8d7fe109.png";